import { render, staticRenderFns } from "./TransportReportResult.vue?vue&type=template&id=f2b66b2a&"
import script from "./TransportReportResult.vue?vue&type=script&lang=js&"
export * from "./TransportReportResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports